// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kGpe","toggle":"styles_toggle__3TMyn","preview":"styles_preview__1PdkQ"};